import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within ThemeProvider');
    }
    return context;
};

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('system');
    const [resolvedTheme, setResolvedTheme] = useState('light');

    useEffect(() => {
        const stored = localStorage.getItem('theme') || 'system';
        setTheme(stored);
    }, []);

    useEffect(() => {
        const root = window.document.documentElement;
        
        if (theme === 'system') {
            const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
            const handleChange = () => {
                const isDark = mediaQuery.matches;
                setResolvedTheme(isDark ? 'dark' : 'light');
                root.classList.toggle('dark', isDark);
            };
            handleChange();
            mediaQuery.addEventListener('change', handleChange);
            return () => mediaQuery.removeEventListener('change', handleChange);
        } else {
            const isDark = theme === 'dark';
            setResolvedTheme(theme);
            root.classList.toggle('dark', isDark);
        }
        
        localStorage.setItem('theme', theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, setTheme, resolvedTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
